import { Component } from "vue";

export default [
  { path: "", redirect: { name: "primaryMarket" }, name: "invest" },
  {
    path: "primary-market",
    component: (): Promise<Component> =>
      import("../components/PrimaryMarket.vue"),
    name: "primaryMarket",
    meta: { withSubMenu: true },
  },
  // Первичный рынок был разбит на два экрана по типу проекта
  // (fund-raising-projects — PROJECT, fund-raising-loan — LOAN) с
  // непересекающимися списками. Теперь это один экран; редиректы оставлены,
  // чтобы сохранённые ссылки не упирались в 404.
  {
    path: "projects",
    redirect: { name: "primaryMarket" },
  },
  {
    path: "fund-raising-projects",
    redirect: { name: "primaryMarket" },
  },
  {
    path: "fund-raising-loan",
    redirect: { name: "primaryMarket" },
  },
  {
    path: "projects/:uuid",
    component: (): Promise<Component> =>
      import("../components/PrimaryMarketProject.vue"),
    name: "primaryMarketProject",
  },
  {
    path: "offers",
    component: (): Promise<Component> =>
      import("../components/SecondaryMarket.vue"),
    name: "secondaryMarket",
    meta: { withSubMenu: true },
  },
  {
    path: "buy-back",
    component: (): Promise<Component> =>
      import("../components/BuyBackOffers.vue"),
    name: "buyBackOffers",
    meta: { withSubMenu: true },
  },
  {
    path: "confirmation/:confirmationUuid",
    component: (): Promise<Component> =>
      import("../components/SignDocumentsPage.vue"),
    name: "signDocuments",
  },
  {
    path: "offers/:uuid",
    component: (): Promise<Component> => import("../components/Offer.vue"),
    name: "secondaryMarketOffer",
  },
  {
    path: "buy-back/:uuid",
    component: (): Promise<Component> => import("../components/Offer.vue"),
    name: "buyBackOffer",
  },
  {
    path: "offers/:uuid/confirmation/:confirmationUuid",
    component: (): Promise<Component> =>
      import("../components/PurchaseConfirmationPrimary.vue"),
    name: "purchaseConfirmation",
  },
  {
    path: "buy-back/:uuid/confirmation/:confirmationUuid",
    component: (): Promise<Component> =>
      import("../components/PurchaseConfirmationBuyBack.vue"),
    name: "purchaseByBackConfirmation",
  },
];
